import { call, options, params } from './helpers';

// Core CRUD
export const getProjects = (payload) =>
	call(`/beta/projects${params(payload)}`);

export const getProjectStats = (payload) =>
	call(`/beta/projects/stats${params(payload)}`);

export const getProject = ({ id }) => call(`/beta/projects/${id}`);

export const createProject = (payload) =>
	call(`/beta/projects`, options(payload, 'POST'));

export const updateProject = ({ id, ...payload }) =>
	call(`/beta/projects/${id}`, options(payload, 'PUT'));

export const updateProjectStatus = ({ id, status }) =>
	call(`/beta/projects/${id}/status`, options({ status }, 'PUT'));

export const deleteProject = ({ id }) =>
	call(`/beta/projects/${id}`, options(null, 'DELETE'));

// Milestones
export const getProjectMilestones = ({ id }) =>
	call(`/beta/projects/${id}/milestones`);

export const createProjectMilestone = ({ id, ...payload }) =>
	call(`/beta/projects/${id}/milestones`, options(payload, 'POST'));

export const updateProjectMilestone = ({ id, milestoneId, ...payload }) =>
	call(`/beta/projects/${id}/milestones/${milestoneId}`, options(payload, 'PUT'));

export const deleteProjectMilestone = ({ id, milestoneId }) =>
	call(`/beta/projects/${id}/milestones/${milestoneId}`, options(null, 'DELETE'));

export const reorderProjectMilestones = ({ id, items }) =>
	call(`/beta/projects/${id}/milestones/reorder`, options({ items }, 'PUT'));

// Tickets
export const createProjectTicket = ({ id, ...payload }) =>
	call(`/beta/projects/${id}/tickets`, options(payload, 'POST'));

export const addProjectTicket = ({ id, ticketId, notes }) =>
	call(`/beta/projects/${id}/tickets/${ticketId}`, options({ notes }, 'POST'));

export const removeProjectTicket = ({ id, ticketId }) =>
	call(`/beta/projects/${id}/tickets/${ticketId}`, options(null, 'DELETE'));

// Work Orders
export const createProjectWorkOrder = ({ id, ...payload }) =>
	call(`/beta/projects/${id}/work-orders`, options(payload, 'POST'));

export const addProjectWorkOrder = ({ id, workOrderId, notes }) =>
	call(`/beta/projects/${id}/work-orders/${workOrderId}`, options({ notes }, 'POST'));

export const removeProjectWorkOrder = ({ id, workOrderId }) =>
	call(`/beta/projects/${id}/work-orders/${workOrderId}`, options(null, 'DELETE'));

// Documents
export const addProjectDocuments = ({ id, files, documentIds, category }) =>
	call(
		`/beta/projects/${id}/documents`,
		options({ files, documentIds, information: {}, bucket: 'projects', category }, 'POST')
	);

export const removeProjectDocument = ({ id, documentId }) =>
	call(`/beta/projects/${id}/documents/${documentId}`, options(null, 'DELETE'));

// Contacts
export const addProjectContact = ({ id, contactId, role, isPrimary }) =>
	call(`/beta/projects/${id}/contacts`, options({ contactId, role, isPrimary }, 'POST'));

export const removeProjectContact = ({ id, contactId }) =>
	call(`/beta/projects/${id}/contacts/${contactId}`, options(null, 'DELETE'));

// Assets
export const addProjectAsset = ({ id, assetId, notes, contractId }) =>
	call(`/beta/projects/${id}/assets`, options({ assetId, notes, contractId }, 'POST'));

export const removeProjectAsset = ({ id, assetId }) =>
	call(`/beta/projects/${id}/assets/${assetId}`, options(null, 'DELETE'));

// Members
export const addProjectMember = ({ id, memberId, role }) =>
	call(`/beta/projects/${id}/members`, options({ memberId, role }, 'POST'));

export const updateProjectMember = ({ id, memberId, role }) =>
	call(`/beta/projects/${id}/members/${memberId}`, options({ role }, 'PUT'));

export const removeProjectMember = ({ id, memberId }) =>
	call(`/beta/projects/${id}/members/${memberId}`, options(null, 'DELETE'));

// Comments
export const getProjectComments = ({ id }) =>
	call(`/beta/projects/${id}/comments`);

export const addProjectComment = ({ id, comment }) =>
	call(`/beta/projects/${id}/comments`, options({ comment }, 'POST'));

// Tasks
export const getProjectTasks = ({ id }) =>
	call(`/beta/projects/${id}/tasks`);

export const createProjectTask = ({ id, ...payload }) =>
	call(`/beta/projects/${id}/tasks`, options(payload, 'POST'));

export const updateProjectTask = ({ id, taskId, ...payload }) =>
	call(`/beta/projects/${id}/tasks/${taskId}`, options(payload, 'PUT'));

export const deleteProjectTask = ({ id, taskId }) =>
	call(`/beta/projects/${id}/tasks/${taskId}`, options(null, 'DELETE'));
